// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: true,
//  apiBase: 'http://localhost:3000/api/v1.0',
    env: 'staging',
    Server: 'https://stgtest.alignorgames.com',
    ManagerBaseURL: 'https://stg-managerportal.alignorgames.com',
    CoachingBaseURL: 'https://stg-coachingportal.alignorgames.com',
    LearnerDashboardBaseURL: 'https://stg-coachingdashboard.alignorgames.com',
    CoachingServerURL: 'https://stg-coachingportal.alignorgames.com/api/v1.0',
    serverGame: 'https://stgtest.alignorgames.com/AuthorGame/',
    published_game: 'https://stgtest.alignorgames.com/PublishedGames/',
    defaultAudio: 'https://stgtest.alignorgames.com/DefaultAudio/',
    Apiversion: 'api/v1.0',
    SERVER_RUNNING_MSG: 'Server runnnig on dev port 3000',
    PayPal_Mode: 'sandbox',
    S3_BUCKET_NAME: 'staging-myalignorgamesbucket',
    S3_ACCESS_KEY: 'AKIAJ3JDNVCAQE5EEM5A',
    S3_SECRET_ACCESS_KEY: '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',
    S3_REGION: 'us-west-1',
    S3_BucketObjectURL: 'https://staging-myalignorgamesbucket.s3.amazonaws.com/',
    S3_BucketI18NURL: 'https://staging-myalignorgamesbucket.s3.amazonaws.com/',
    S3_AuthorGamePath: 'AuthorGame/',
    S3_PublishedGames: 'PublishedGames/',
    S3_CharactersPath: 'SpriteImages/',
    S3_AudiosPath: 'DefaultAudio/',
    S3_CourseImgPath: 'CourseImages/',
    S3_JourneyImgPath: 'JourneyImages/',
    S3_CourseExcels: 'CourseExcels/',
    S3_VideosPath: 'videos/',
    S3_ResourcesPath: 'Resources/',
    S3_VideosSrtFilesPath: 'VideosSrtFiles/',
    S3_CommonResources: 'CommonResources/',
    S3_StylesPath: 'Styles/',
    S3_IconsPath: 'Icons/',
    S3_GameStylePath: 'GameStyle/'

// production: true,
//   //  apiBase: 'http://localhost:3000/api/v1.0',
//     env: 'qaprod',
//     Server: 'https://qaprod.alignorgames.com',
//     ManagerBaseURL: 'https://stg-managerportal.alignorgames.com',
//     serverGame: 'https://qaprod.alignorgames.com/AuthorGame/',
//     published_game: 'https://qaprod.alignorgames.com/PublishedGames/',
//     defaultAudio: 'https://qaprod.alignorgames.com/DefaultAudio/',
//     Apiversion: 'api/v1.0',
//     SERVER_RUNNING_MSG: 'Server runnnig on dev port 3000',
//     PayPal_Mode: 'production',
//     S3_BUCKET_NAME: 'myalignorgamesbucket',
//     S3_ACCESS_KEY: 'AKIAJ3JDNVCAQE5EEM5A',
//     S3_SECRET_ACCESS_KEY: '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',
//     S3_REGION: 'us-west-1',
//     S3_BucketObjectURL: 'https://bucket.alignorgames.com/',
//     S3_BucketI18NURL: 'https://myalignorgamesbucket.s3-us-west-1.amazonaws.com/',
//     S3_AuthorGamePath: 'AuthorGame/',
//     S3_PublishedGames: 'PublishedGames/',
//     S3_CharactersPath: 'SpriteImages/',
//     S3_AudiosPath: 'DefaultAudio/',
//     S3_CourseImgPath: 'CourseImages/',
//     S3_JourneyImgPath: 'JourneyImages/',
//     S3_CourseExcels: 'CourseExcels/',
//     S3_VideosPath: 'videos/',
//     S3_ResourcesPath: 'Resources/',
//     S3_VideosSrtFilesPath: 'VideosSrtFiles/',
//     S3_CommonResources: 'CommonResources/',
//     S3_StylesPath: 'Styles/',
//     S3_IconsPath: 'Icons/',
//     S3_GameStylePath: 'GameStyle/'
};




// WEBPACK FOOTER //
// ./src/environments/environment.ts